import { cn } from "@/lib/utils";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface TickTextProps {
  itemList: string[];
  textClassName?: string;
  id?: string;
}

const TickText: React.FC<TickTextProps> = ({ itemList, textClassName, id }) => {
  return (
    <div key={id} className="flex flex-col space-y-1">
      {itemList.map((e, index) => (
        <p key={`${id}-${index}`} className={cn("text-gray-600 font-normal", textClassName)}>
          <FontAwesomeIcon icon={faCheck} className="text-green-600" /> {e}
        </p>
      ))}
    </div>
  );
};

export default TickText;
